import type { IAnswer } from '../../ApprovalForms/types';
import type { IApplicantQuestion } from '../../Components/Utilities/QuestionFieldGenerator';

export const getAnswerAttributes = (
  question: IApplicantQuestion,
  index: number,
  answers: Record<number, string | number | Record<string, string | boolean>>,
  ratings: Record<number, number>,
  formResponse?: IAnswer[]
) => {
  switch (question.type) {
    case 'RadioButtonField':
    case 'SelectField':
      return {
        field_id: question.id,
        field_choice_id: answers[question.id],
        rating_value: ratings[question.id],
        ...(formResponse?.[index]?.id && { id: formResponse[index]?.id })
      };
    case 'CheckBoxField':
      return {
        field_id: question.id,
        field_choice_ids:
          answers[question.id] &&
          Object.entries(answers[question.id])
            .filter(([_, value]) => value)
            .map(([id]) => id),
        rating_value: ratings[question.id],
        ...(formResponse?.[index]?.id && { id: formResponse[index]?.id })
      };
    default:
      return {
        field_id: question.id,
        data: answers[question.id],
        rating_value: ratings[question.id],
        ...(formResponse?.[index]?.id && { id: formResponse[index]?.id })
      };
  }
};
